export default __webpack_public_path__ + "static/media/tasksIcon.a27a0927.svg";